<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业专家"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <h2>行业专家</h2>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in explistdata" :key="index" @click="hanle(index)">
          <img :src='item.img' height="200" width="160"/>
          <div>
            <h3>{{item.name}}</h3>
            <p :title='item.title'><b>职称：</b>{{ item.title }}</p>
            <p :title='item.position'><b>职务：</b>{{ item.position }}</p>
            <p :title='item.units'><b>单位：</b>{{ item.units }}</p>
            <p :title='item.research' class="research"><b>研究方向：</b>{{ item.research }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'SearchIndex',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      explistdata:[
        {img: require('../../assets/img/001.jpg'),name:'俞建勇',title:'教授',position:'东华大学党委副书记、校长',units:'东华大学',research:'高性能纤维及其复合材料，功能性高分子材料',book:'《集聚纺纱原理》、《静电纺丝与纳米纤维》、《高性能纤维制品成形技术》、《中国纺织产业科技创新发展研究2016-2030》、《功能静电纺纤维材料》',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t1964年5月26日出生于上海长宁区，籍贯浙江省&nbsp;，纺织材料专家，<a href="https://baike.baidu.com/item/%E4%B8%AD%E5%9B%BD%E5%B7%A5%E7%A8%8B%E9%99%A2%E9%99%A2%E5%A3%AB/5925613" target="_blank">中国工程院院士</a>&nbsp;，<a href="https://baike.baidu.com/item/%E4%B8%9C%E5%8D%8E%E5%A4%A7%E5%AD%A6/342331" target="_blank">东华大学</a>校长、党委副书记、纺织材料学科教授、博士生导师，<a href="https://baike.baidu.com/item/%E7%BA%BA%E7%BB%87%E7%A7%91%E5%AD%A6%E4%B8%8E%E5%B7%A5%E7%A8%8B/152025" target="_blank">纺织科学与工程</a>一级学科国家重点学科责任人。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．科研综述\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t从事高分子材料生产、教学和科研四十余年。发表论文二百余篇，申请专利八十余项。除教学和指导研究生工作外,主要从事的研究领域包括：\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(1)高性能纤维的制备和研究：高强高模PE纤维；碳纤维的研制和结构性能研究；功能和<a href="https://baike.baidu.com/item/%E6%94%B9%E6%80%A7%E7%BA%A4%E7%BB%B4/218791" target="_blank">改性纤维</a>的制备。\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(2)非纤高分子材料及复合材料的制备及应用：高分子材料增强混凝土，增强沥青；纳米颗粒增强复合材料；新型碳泡沫的研制及表征。\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(3)应用基础理论研究大分子缠结，材料防裂模型和计算机模拟，高分子材料压缩强度和压缩模量。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t3． 所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t截至2012年，俞建勇先后获得国家及省部级科技奖14项，主要包括国家科技进步二等奖1项、国家技术发明二等奖1项、中国纺织工业协会科技进步一等奖3项、浙江省科技进步奖一等奖1项、上海市技术发明二等奖1项、上海市科技进步二等奖1项、教育部科技进步二等奖1项、中国纺织工业协会科技进步二等奖2项等。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t4．承担项目情况\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t截至2012年，俞建勇先后主持完成了国家“十五”科技攻关项目、国家重大军工配套项目、教育部博士点基金项目、教育部优秀青年教师资助计划项目、上海市重大科研项目、江苏省重大科技成果转化项目、浙江省重点科研项目等40多项国家、省部级项目及大量横向科研项目；国家“十一五”科技支撑计划课题、国家自然科学基金课题等多项国家、省部级和横向科研项目\n' +
            '</p>\n' +
            '<p>\n' +
            '\t<br />\n' +
            '</p>'},
        {img:require('../../assets/img/006.jpg'),name:'王华平',title:'教授',position:'东华大学材料学院常务副院长',units:'东华大学',research:'纤维工程和科学',book:'',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t王华平，东华大学研究员，博士生导师，1965年7月出生，1986年获成都科技大学化学纤维专业学士学位，1989年获中国纺织大学化学纤维硕士学位，2001年获东华大学材料学博士学位。1989年至今一直从事纤维科学和工程研究，现担任高性能纤维及制品教育部重点实验室（B）主任，东华大学研究院副院长，产业用纺织品教育部工程研究中心副主任，兼任中国纺织工程学会化纤专业委员会副主任等职务。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．科研综述\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t主要研究成果有仿毛仿棉型细旦中空涤纶短丝，一步法花色纺丝工艺与设备，一步法制备高收缩<a href="https://baike.baidu.com/item/%E6%B6%A4%E7%BA%B6%E9%95%BF%E4%B8%9D/9917882" target="_blank">涤纶长丝</a>，再生料制备高压缩弹性短纤维技术与工程，新型功能化(远红外、负氧离子)纤维，超细电气石纳米在化纤、涂料中的应用，远红外腈纶纤维（中石化三等奖），粗旦多中空涤纶纤维（中石油重大攻关项目）转光农用纤维无纺布抗紫外<a href="https://baike.baidu.com/item/%E7%BA%B3%E7%B1%B3%E4%BA%8C%E6%B0%A7%E5%8C%96%E9%92%9B/5602034" target="_blank">纳米二氧化钛</a>表面处理等。&nbsp;2020年5月，获得第二届全国创新争先奖。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t3． 所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t先后获国家科技进步二等奖4项、省部级科技成果奖18项，作为学术带头人，培养年轻教授7名，形成了一支集基础研究、技术和工程开发为一体的高水平教学科研团队。汲取科研之精华，精心打造实践基地，培养了一大批德才兼备的博士、硕士、学士毕业生，为纤维、材料等相关行业输送优秀专业人才。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t4.人才培养\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t培养博士生12名、硕士39名，先后与UCLA、UC Davis等8所国际一流大学合作，帮助和资助5名青年教师出国进修与20余次参加国际学术会议，与国内外高效联合培养10名博士研究生。学生获奖与优秀比例超过50%，获上海市社会实践活动优秀团队1次，校社会实践优秀团队4次，上海市“科创杯”创新一等奖1次，创业一等奖2次，创新三等奖2次。\n' +
            '</p>'},
        {img:require('../../assets/img/007.jpg'),name:'覃小红',title:'教授',position:'东华大学纺织学院纺织材料系主任',units:'东华大学',research:'纺织材料与纺织品设计，纺织生物材料与技术，非织造材料与工程',book:'',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t1977年4月出生，中共党员，博士，<a href="https://baike.baidu.com/item/%E4%B8%9C%E5%8D%8E%E5%A4%A7%E5%AD%A6%E7%BA%BA%E7%BB%87%E5%AD%A6%E9%99%A2/850970" target="_blank">东华大学纺织学院</a>纺织材料系主任、教授，<a href="https://baike.baidu.com/item/%E5%8D%9A%E5%A3%AB%E7%94%9F%E5%AF%BC%E5%B8%88/11051132" target="_blank">博士生导师</a>。从事多维度亚微米纤维集合体介质诱导成形理论与产业化研究。全国优秀博士学位论文获得者。主持国家科技支撑子课题、国家自然科学基金（4项）、新世纪人才计划等项目20余项。获2014年<a href="https://baike.baidu.com/item/%E4%B8%AD%E5%9B%BD%E7%BA%BA%E7%BB%87%E5%B7%A5%E4%B8%9A%E8%81%94%E5%90%88%E4%BC%9A/10539238" target="_blank">中国纺织工业联合会</a>科学技术一等奖。2016年3月，获“上海市巾帼创新新秀奖”，同时被授予“上海市三八红旗手”称号。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．科研综述\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t长期致力于微纳米尺度纤维及纱线的批量制备、结构和性能表征与研究，注重实验研究与理论探索相结合，取得了系列具有创新性的研究成果。曾受邀担任2009年美国纤维协会分会主席，受邀在2012年世界生物材料大会上做the Rapid Fire Session的邀请汇报。发表文章60余篇，其中SCI/EI文章近40篇，包括多篇纺织类权威SCI文章。申请专利20余项，已有10余项授权并在企业中推广。文章累计引用次数为234次，单篇引用次数最高76次。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t3． 所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t(1)上海市“曙光”学者\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(2) 东华大学优秀青年教师称号和上海市优秀青年教师基金\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(3) 获第十六届<a href="https://baike.baidu.com/item/%E4%B8%AD%E5%9B%BD%E9%9D%92%E5%B9%B4%E7%A7%91%E6%8A%80%E5%A5%96/10301817" target="_blank">中国青年科技奖</a>等\n' +
            '</p>'},
        {img:require('../../assets/img/009.jpg'),name:'王依民',title:'教授、研究员',position:'',units:'',research:'高性能纤维及其复合材料，功能性高分子材料',book:'',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t1950年03月1日 出生，博士，\n' +
            '职称是研究员 所属部门是化学纤维研究所，&nbsp;<a href="https://baike.baidu.com/item/%E5%8D%9A%E5%A3%AB%E7%94%9F%E5%AF%BC%E5%B8%88/11051132" target="_blank">博士生导师</a>，曾任东华大学学术委员会委员，东华大学学位委员会委员，材料学院学术委员会主任。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．科研综述\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t从事高分子材料生产、教学和科研四十余年。发表论文二百余篇，申请专利八十余项。除教学和指导研究生工作外,主要从事的研究领域包括：\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(1)高性能纤维的制备和研究：高强高模PE纤维；碳纤维的研制和结构性能研究；功能和<a href="https://baike.baidu.com/item/%E6%94%B9%E6%80%A7%E7%BA%A4%E7%BB%B4/218791" target="_blank">改性纤维</a>的制备。\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(2)非纤高分子材料及复合材料的制备及应用：高分子材料增强混凝土，增强沥青；纳米颗粒增强复合材料；新型碳泡沫的研制及表征。\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(3)应用基础理论研究大分子缠结，材料防裂模型和计算机模拟，高分子材料压缩强度和压缩模量。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t3．所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t(1)国家科技进步二等奖（<a href="https://baike.baidu.com/item/%E9%BB%8F%E8%83%B6%E5%9F%BA%E7%A2%B3%E7%BA%A4%E7%BB%B4/7455164" target="_blank">黏胶基碳纤维</a>，2004）\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(2)上海市科技进步一等奖（高强高模<a href="https://baike.baidu.com/item/%E8%81%9A%E4%B9%99%E7%83%AF%E7%BA%A4%E7%BB%B4/8260904" target="_blank">聚乙烯纤维</a>，2005）\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(3)桑麻科技二等奖（水泥防裂<a href="https://baike.baidu.com/item/%E8%81%9A%E4%B8%99%E7%83%AF%E7%BA%A4%E7%BB%B4/10919368" target="_blank">聚丙烯纤维</a>，2003）\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(4)上海市优秀产学研一等奖（九孔<a href="https://baike.baidu.com/item/%E8%81%9A%E9%85%AF%E7%BA%A4%E7%BB%B4/10919395" target="_blank">聚酯纤维</a>，2001）、二等奖（超细旦聚丙烯纤维，2001）\n' +
            '</p>\n' +
            '<p>\n' +
            '\t(5)有突出贡献中青年专家，享受政府津贴（1994）\n' +
            '</p>'},
        {img:require('../../assets/img/024.jpg'),name:'郁崇文',title:'教授、博导',position:'',units:'东华大学',research:'纤维集合体成型的有关理论与技术等',book:'《纺纱工艺学》、《纺纱实验教程》等',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t2000.3至今 &nbsp;&nbsp;&nbsp;东华大学\t&nbsp;&nbsp;&nbsp;教授，博士生导师\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1999.7-2000.3\t东华大学\t&nbsp;&nbsp;&nbsp;教授\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1996.1-1999.7\t中国纺织大学\t副教授\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1990.7-1996.1\t中国纺织大学\t讲师\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1987.1-1990.7\t中国纺织大学\t助教\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．技术专利\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t基于纤维排列的精梳模拟的精梳工艺参数确定方法、一种带有梳并联工序的精梳纺纱方法、含阻燃聚酰胺纤维和聚芳酯纤维的混纺纱的生产方法等。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t3． 所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t国家万人计划领军人才（教学名师）、“全国优秀教师”、中国纺织工业协会科技进步一等奖等\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t4．承担项目情况\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t1.国家自然科学基金委员会，面上项目，51773034，基于纱条中纤维排列的牵伸过程研究，2018.01~2021.12，70万元，在研，主持\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2. 现代农业技术体系建设项目，CARS-19-E25，麻类体系纤维性能改良，2016.01~2020.12，350万元，已结题，主持\n' +
            '</p>\n' +
            '<p>\n' +
            '\t3. 万人计划（领军人才），纺织工程，2015年等\n' +
            '</p>'},
        {img:require('../../assets/img/023.jpg'),name:'王直杰',title:'教授',position:'院长',units:'东华大学',research:'神经认知动力学、机器学习等有关的智能科学',book:'',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t2005/9 - 至今，东华大学，信息科学与技术学院，教授\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2010/10 –&nbsp;2011/9, 香港理工大学，研究员\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2000/9 –&nbsp;2002/9, 日本东京大学，博士后\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1999/9 - 2005/8，东华大学，信息科学与技术学院，副教授\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1997/4 - 1999/8，东华大学，信息科学与技术学院，讲师\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．科研综述\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t一直从事神经认知动力学、机器学习等有关的智能科学、智能技术方面的研究工作。是国内最早从事遗传算法有关的智能技术的研究者之一，于1992年发表了有关遗传算法方面的研究论文。2000.10-2012.10在日本东京大学Aihara教授实验室完成了计算神经科学方面的博士后研究工作，主要从事神经网络的动态特性以及基于混沌神经网络的联想记忆研究。主持完成了国家自然科学基金面上项目、上海市科技攻关项目等科研项目10多项。在《Physical Review E》、《Neural Networks》、《IEEE Transactions on Neural Networks and Learning Systems》、《Nerocomputing》、《International Journal of Neural Systems》等国际著名杂志及其它重要出版物上发表了神经计算、类脑智能、深度学习等方面的研究论文30多篇。\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t3． 所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t曾获中国纺织工业协会纺织高等教育教学成果奖一等奖、上海市优秀教学成果一等奖等\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t4.人才培养\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t已培养博士研究生、硕士研究生50多名。\n' +
            '</p>\n' +
            '<p>\n' +
            '\t&nbsp;\n' +
            '</p>'},
        {img:require('../../assets/img/022.jpg'),name:'沈恒根',title:'教授',position:'原院长',units:'东华大学',research:'能源环境保护',book:'',personalprofile:'<h4>\n' +
            '\t1．个人履历\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t1974.3-1977.2 陕西眉县第五村公社 知青，组长\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1977.3-1978.2西北电管局宝鸡发电厂，工人\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1982.3-1998.12西安建筑科技大学 助教-讲师-副教授-教授，教研室副主任-主任\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1996.10-1998.12 西安交通大学动力工程与工程热物理工作站 博士后\n' +
            '</p>\n' +
            '<p>\n' +
            '\t1999.1-2020.10中国纺织大学-改名东华大学 教授，副院长-院长、系主任、学科带头人。\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2020.10-今 东华大学退休返聘 教授\n' +
            '</p>\n' +
            '<h4>\n' +
            '\t2．技术专利\n' +
            '</h4>\n' +
            '<h4>\n' +
            '\t3． 所获荣誉\n' +
            '</h4>\n' +
            '<p>\n' +
            '\t1995年国家科技进步奖（2），同年获得国家国务院政府特殊津贴；\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2009年中国技术市场协会金桥奖（1）；\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2010年中国纺织工业协会科技进步三等奖（1）；\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2013年中国职业安全健康科学技术二等奖（1）；\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2016年获得全国暖通空调行业最高荣誉奖第四届“吴元炜暖通空调奖”；\n' +
            '</p>\n' +
            '<p>\n' +
            '\t2017年中国纺织工业联合会教学成果二等奖等；\n' +
            '</p>\n' +
            '<p>\n' +
            '\t中国电机工程学会电力环保委员会2017年度2018年度先进个人。\n' +
            '</p>'},
        {img:require('../../assets/img/jr01.jpg'),name:'伍戈',title:'',position:'首席经济学家',units:'长江证券',research:'宏观经济与货币政策与国际金融等',book:'',personalprofile:'伍戈，经济学博士，研究员。长江证券首席经济学家，曾长期供职于中国人民银行货币政策部门，并在国际货币基金组织担任经济学家。伍博士是中国经济学最高奖——“孙冶方经济科学奖”得主，还是浦山政策研究奖、刘诗白经济学奖获得者，“远见杯”中国经济、全球市场预测双冠军。担任清华、复旦、人大兼职教授及导师。 [6]&nbsp; 曾应邀参加克强总理主持召开的经济座谈会并专题发言。<br />\n' +
            '伍博士还担任中国金融四十人论坛（CF40）成员、中国世界经济学会理事、中国首席经济学家论坛理事等社会职务。其主要研究方向为宏观经济、货币政策与国际金融等。曾在《经济研究》、《金融研究》、《世界经济》、《数量经济技术经济研究》、《IMF Working Paper》、《China Economist》等国内外期刊发表数篇中英文论文。著作包括《货币数量、利率调控与政策转型》 、《成本冲击、通胀容忍度与宏观政策》、《信用创造、货币供求与经济结构》等。<br />\n' +
            '<div>\n' +
            '\t<br />\n' +
            '</div>'},
        {img:require('../../assets/img/jr05.jpg'),name:'肖立晟',title:'',position:'全球宏观经济研究室主任',units:'中国社会科学院',research:'宏观经济和国际金融',book:'',personalprofile:'长期跟踪研究国内外宏观经济形势以及人民币汇率问题。在《经济研究》、《管理世界》等核心期刊上发表多篇论文。在《人民日报》、《经济日报》等媒体上发表财经评论逾100篇。参加国家与部委层面的宏观经济研讨会，并撰写大量决策咨询报告，多次荣获中国社会科学院优秀对策信息奖（对策研究类）。兼任中国金融40人青年论坛研究员，中国科学技术大学国际金融研究院研究员，西南财经大学国际政治与金融安全智库研究员，中山大学国际金融学院硕士生导师，对外经贸大学金融学院硕士生导师。曾担任清华大学经管学院EMBA、中国人民大学金融学院EMBA授课老师。'},
        {img:require('../../assets/img/jr06.jpg'),name:'赵庆明',title:'',position:'高级研究员',units:'中国建设银行',research:'国际金融',book:'《人民币资本项目可兑换及国际化研究》（2005年，中国金融出版社）、《中国汇率改革：问题与思考》（2007年，中国金融出版社）',personalprofile:'赵庆明，经济学博士，国际金融问题专家。毕业于中国社会科学院研究生院，获经济学博士学位。曾在中国人民银行金融研究所从事博士后研究工作。某上市银行从事宏观经济分析和商业银行业务研究。 主要研究领域：汇率与外汇业务、中国外汇体制改革、中国宏观经济分析等。 在《金融研究》、《国际金融研究》、《中国货币市场》、《国际贸易问题》以及《经济日报》、《中国证券报》、《上海证券报》、《金融时报》、《中国经济时报》等国内著名学术杂志和重要财经报纸发表学术论文、工作报告、财经时评等100余篇。 出版专著2部，分别是：。 主持和参与完成的课题报告获中国人民银行年度重点课题评比一、二、三等奖各一次。'}

      ]
    }
  },
  methods: {
    hanle(index) {
      localStorage.setItem('expdata',JSON.stringify(this.explistdata[index]))
      this.$router.push('/expertd')
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.experts-title h2{
  font-family: "fzskjt";
  line-height: 59px;
  color:#fff;
  font-style: oblique;
  padding-left: 20px;
}

.experts-list{
  padding: 30px 0 0 18px;
}

.experts-list li{
  width: 488px;
  height: 210px;
  padding: 10px;
  margin: 0 12px 25px 12px;
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
  display: flex;
  justify-content: space-between;
}

.experts-list li:hover{
  background: #fff;
  border: 2px solid #2095EF;
  padding: 8px;
}

.experts-list li>div{
  margin-left: 12px;
}

.experts-list li h3{
  font-size: 21px;
  margin-bottom: 12px;
}

.experts-list li p{
  line-height: 160%;
  width: 306px;
  margin: 3px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.experts-list li p.research{
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
}

.experts-list li>img{
  padding: 5px;
  background: #E3E9F6;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-experts-list.vue